import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
import { defineAsyncComponent } from "vue";
import { useUserStore } from "@/stores/modules/user";
export const projectManagementRouter: RouteRecordRaw[] = [
    {
        path: "/warehouseProjectManagement",
        name: "WarehouseProjectManagement",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "项目管理"
            // isNotShowHeader: true
        },
        redirect: "/warehouseProjectManagement/index",
        children: [
            {
                path: "index",
                name: "WarehouseProject",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/projectManage/project/index.vue");
                    }
                }),
                meta: {
                    title: "项目管理",
                    pageType: PAGE_TYPE.LIST.code,
                    hidden: true,
                    activeMenu: "WarehouseProjectManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        },
                        {
                            label: "完结",
                            value: "ROLE_S_PROJECT_BUY_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "project/add",
                name: "WarehouseProjectAdd",
                component: () => import("@/views/pages/warehouseSupervision/projectManage/project/add/index.vue"),
                meta: {
                    title: "新增项目",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "WarehouseProjectManagement",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "project/edit/:id",
                name: "WarehouseProjectEdit",
                component: () => import("@/views/pages/warehouseSupervision/projectManage/project/add/index.vue"),
                meta: {
                    title: "修改项目",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "WarehouseProjectManagement",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "project/detail/:id",
                name: "WarehouseProjectInfo",
                component: () => import("@/views/pages/warehouseSupervision/projectManage/project/info/index.vue"),
                meta: {
                    title: "项目详情",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    activeMenu: "WarehouseProjectManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        },
                        {
                            label: "完结",
                            value: "ROLE_S_PROJECT_BUY_MANAGE"
                        }
                    ],
                    isNotShowHeader: true
                }
            }
        ]
    }
];
